import { useMemo } from 'react';
import { type ActiveRangeData, getActiveDataForStartDate } from './start-date.helpers';

export default function useActiveDataForStartDate<Record extends ActiveRangeData>(
  records: Record[] | undefined,
  startDate: string | undefined
): Record[] {
  return useMemo(
    () => (startDate ? getActiveDataForStartDate(records || [], startDate) : []),
    [records, startDate]
  );
}
